/* Force restored teal brand stylesheet (CDN/page_cache often sticks to corrupt fit-theme.css) */
(function(){
  try{
    var href='https://fitprotection.com/cdn/shop/t/102/assets/fit-theme-v2.css?fitb=force-teal-bsalign-20260819b';
    var links=document.querySelectorAll('link[rel="stylesheet"]');
    var hasFresh=false;
    for(var i=0;i<links.length;i++){
      var h=String(links[i].href||'');
      if(h.indexOf('fit-theme-v2.css')!==-1 && h.indexOf('bsalign-20260819b')!==-1){ hasFresh=true; break; }
    }
    if(hasFresh) return;
    var l=document.createElement('link');
    l.rel='stylesheet';
    l.href=href;
    (document.head||document.documentElement).appendChild(l);
  }catch(e){}
})();

/* FIT freeze-bounce r3 — must run on every collection paint */
(function(){
  try{
    var path=location.pathname||'';
    if(path.indexOf('/collections/')!==0) return;
    if(/[?&]view=/.test(location.search||'')) return;
    var html=document.documentElement&&document.documentElement.innerHTML||'';
    var frozen=html.indexOf('main_v11')!==-1
      || html.indexOf('fit-col-cache: card-reviews')!==-1
      || (html.indexOf('id="shopGrid"')!==-1 && html.indexOf('function brandKey')===-1 && html.indexOf('__FIT_COL_FILTERS_SRC')===-1 && html.indexOf('bind-r3')===-1);
    if(!frozen) return;
    var isRv=/shop-rvs|rv-covers|suffix-rv/i.test(path+' '+(document.body&&document.body.className||''));
    var u=new URL(location.href);
    u.searchParams.set('view', isRv?'rv-live':'utv-live');
    location.replace(u.pathname+u.search+u.hash);
  }catch(e){}
})();

/* ACC / LOXX kit: page_cache can freeze cover-builder HTML after templateSuffix=accessory */
(function(){
  try{
    var path=location.pathname||'';
    if(!/^\/products\/(loxx-kit|loxx-retention-kit|fit-vinyl-cleaner-kit|fit-vinyl-cleaner|removable-magnets|replacement-magnets)\/?$/.test(path)) return;
    if(/[?&]view=accessory/.test(location.search||'')) return;
    if(document.getElementById('accessoryPdp') && !document.getElementById('retOpts')) return;
    var html=document.documentElement&&document.documentElement.innerHTML||'';
    var stuckBuilder = html.indexOf('id="retOpts"')!==-1 || html.indexOf('Add this cover')!==-1 || html.indexOf('main_v26')!==-1;
    if(!stuckBuilder && document.getElementById('accessoryPdp')) return;
    var u=new URL(location.href);
    u.searchParams.set('view','accessory');
    location.replace(u.pathname+u.search+u.hash);
  }catch(e){}
})();

/* Accessories page: stale page_cache missing Ships-in-5-days cards */
(function(){
  try{
    var path=location.pathname||'';
    if(!/^\/pages\/accessories\/?$/.test(path)) return;
    if(/[?&]view=accessories-v2/.test(location.search||'')) return;
    var html=document.documentElement&&document.documentElement.innerHTML||'';
    if(html.indexOf('Ships in 5 days')!==-1 && html.indexOf('card-ships')!==-1) return;
    var u=new URL(location.href);
    u.searchParams.set('view','accessories-v2');
    location.replace(u.pathname+u.search+u.hash);
  }catch(e){}
})();

/* Warranty page: stale cache missing claim form */
(function(){
  try{
    var path=location.pathname||'';
    if(!/^\/pages\/warranty\/?$/.test(path)) return;
    if(/[?&]view=warranty-v2/.test(location.search||'')) return;
    if(document.getElementById('warrantyClaimForm')) return;
    var u=new URL(location.href);
    u.searchParams.set('view','warranty-v2');
    location.replace(u.pathname+u.search+u.hash);
  }catch(e){}
})();

/* Homepage IndexController page_cache: bounce off conflicted HTML, then scrub */
(function(){
  try{
    var L=Array(8).join('<');
    var R=Array(8).join('>');
    var html=document.documentElement&&document.documentElement.innerHTML||'';
    if(html.indexOf(L)===-1 && html.indexOf(R)===-1) return;
    var path=location.pathname||'/';
    var isHome=path==='/' || path==='' || path==='/index' || path==='/index.html';
    if(isHome && !/[?&]view=home-v56/.test(location.search||'')){
      var u=new URL(location.href);
      u.searchParams.set('view','home-v56');
      location.replace(u.pathname+u.search+u.hash);
      return;
    }
    function stripConflicts(root){
      if(!root) return;
      var walker=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var kill=[];
      var n;
      while((n=walker.nextNode())){
        var t=n.nodeValue||'';
        if(t.indexOf(L)!==-1 || t.indexOf(R)!==-1 || /^\s*=======\s*$/.test(t)){
          kill.push(n);
        }
      }
      kill.forEach(function(node){
        try{ node.parentNode && node.parentNode.removeChild(node); }catch(e){}
      });
      var hint=root.querySelector && root.querySelector('.cart-checkout-hint');
      var trust=root.querySelector && root.querySelector('a[href="/pages/reviews"]');
      if(hint && trust && String(root.innerHTML||'').indexOf('Free shipping to the lower 48')!==-1){
        try{ hint.parentNode && hint.parentNode.removeChild(hint); }catch(e){}
      }
    }
    stripConflicts(document.getElementById('cartDrawer')||document.body);
    fetch('/?sections=cart-drawer-v2',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var h=d&&(d['cart-drawer-v2']||d[Object.keys(d)[0]]);
        if(!h || String(h).indexOf(L)!==-1) return;
        var cur=document.getElementById('shopify-section-cart-drawer-v2');
        if(!cur) return;
        var wrap=document.createElement('div');
        wrap.innerHTML=h;
        var next=wrap.firstElementChild;
        if(next) cur.replaceWith(next);
      }).catch(function(){});
  }catch(e){}
})();

/**
 * fit-error-guard.js BUILD_MARKER_JSZERO_20260804d
 * Clarity often reports iOS WebView / password-manager noise as "site" JS errors:
 *   - window.webkit.messageHandlers.*
 *   - _AutofillCallbackHandler / AutofillCallbackHandler
 * Those are not FIT theme bugs. We swallow only that known noise so it doesn't
 * pollute sessions or trip fragile third-party listeners. Real app errors still surface.
 */
(function () {
  'use strict';
  if (window.__fitErrorGuard) return;
  window.__fitErrorGuard = true;

  /* Block stale fit-app double-CDN inject + null textContent selectors */
  try { window.__fitShopGridFix = true; } catch (eF) {}
  try {
    if (!window.__fitAppendPatch) {
      window.__fitAppendPatch = true;
      var _ap = Node.prototype.appendChild;
      Node.prototype.appendChild = function (n) {
        try {
          if (n && n.tagName === 'SCRIPT' && n.src && String(n.src).indexOf('/cdn/cdn/') !== -1) {
            n.src = String(n.src).replace('/cdn/cdn/', '/cdn/');
          }
        } catch (eA) {}
        return _ap.apply(this, arguments);
      };
    }
  } catch (eP) {}

  /* Define no-op globals some WebViews call without injecting first */
  try {
    if (typeof window._AutofillCallbackHandler === 'undefined') {
      window._AutofillCallbackHandler = function () {};
    }
  } catch (e0) {}
  try {
    if (typeof window.AutofillCallbackHandler === 'undefined') {
      window.AutofillCallbackHandler = function () {};
    }
  } catch (e1) {}

  function isNoise(msg, src, stack) {
    var m = String(msg || '') + ' ' + String(src || '') + ' ' + String(stack || '');
    return /webkit\.messageHandlers|messageHandlers\.[A-Za-z0-9_]+|AutofillCallbackHandler|_AutofillCallbackHandler|Java bridge|Java object is gone|Null is not an object \(evaluating '.*\.webkit|undefined is not an object \(evaluating '.*\.messageHandlers|Can't find variable: _?Autofill|ReferenceError:.*Autofill|Cannot set properties of null \(setting 'textContent'\)|Identifier 'CATEGORY' has already been declared|Script error\.?$/i.test(m);
  }

  window.addEventListener(
    'error',
    function (e) {
      try {
        var msg = (e && e.message) || (e && e.error && e.error.message) || '';
        var src = (e && e.filename) || '';
        var stack = (e && e.error && e.error.stack) || '';
        if (isNoise(msg, src, stack)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return true;
        }
      } catch (ignore) {}
    },
    true
  );

  window.addEventListener('unhandledrejection', function (e) {
    try {
      var r = e && e.reason;
      var msg = r && (r.message || String(r));
      var stack = r && r.stack;
      if (isNoise(msg, '', stack)) {
        e.preventDefault();
      }
    } catch (ignore) {}
  });

  /* Soft-stub: only when webkit exists but messageHandlers is missing (broken IABs) */
  try {
    if (window.webkit && typeof window.webkit === 'object' && !window.webkit.messageHandlers) {
      window.webkit.messageHandlers = new Proxy(
        {},
        {
          get: function () {
            return { postMessage: function () {} };
          }
        }
      );
    }
  } catch (ignore2) {}
})();

/* FIT emergency rehydrate — page_cache bypass 20260813 */
(function(){
  try{
    if(window.__FIT_EG_REHYDRATE) return; window.__FIT_EG_REHYDRATE=1;
    function isHome(){var p=(location.pathname||'/').replace(/\/+$/,'')||'/';return p==='/'||p==='/index';}
    function isProduct(){return /^\/products\//.test(location.pathname||'');}
    function runScripts(root){if(!root)return;root.querySelectorAll('script').forEach(function(old){var typ=(old.getAttribute('type')||'').toLowerCase();if(typ&&typ!=='text/javascript'&&typ!=='application/javascript'&&typ!=='module')return;try{var s=document.createElement('script');if(old.src){s.src=old.src;s.async=false;}else s.textContent=old.textContent||'';if(typ)s.type=old.type;if(old.parentNode)old.parentNode.replaceChild(s,old);}catch(e){}});}
    function homeGo(){
      if(!isHome()||window.__FIT_HOME_LIVE_V54)return;
      var html=document.documentElement.innerHTML||'';
      if(html.indexOf('data-bs-version="v55')!==-1&&html.indexOf('-v21')!==-1)return;
      window.__FIT_HOME_LIVE_V54=true;
      fetch('/index?sections=home-main-v55',{credentials:'same-origin',cache:'no-store'})
        .then(function(r){return r.json();})
        .then(function(data){
          var h=data&&data['home-main-v55']; if(!h||h.indexOf('data-bs-version')===-1)return;
          var t=document.querySelector('[id*="home_main"]')||(document.getElementById('fitment')&&document.getElementById('fitment').closest('[id^="shopify-section"]'))||document.querySelector('#MainContent [id^="shopify-section"]');
          if(!t)return;
          var d=document.createElement('div'); d.innerHTML=h; var f=d.firstElementChild||d; t.replaceWith(f); runScripts(f);
          document.body.setAttribute('data-fit-home-live','v55-eg');
        }).catch(function(){});
    }
    function pdpGo(){
      if(!isProduct()||window.__FIT_PDP_EG)return;
      var path=location.pathname||'';
      if(!/rv|trailer|rockwood|montana|flagstaff|keystone|geo-pro|mini-lite|micro-lite/i.test(path+' '+(document.title||'')))return;
      var hero=document.getElementById('galleryMain');
      var src=hero&&hero.getAttribute('src')||'';
      var html=document.documentElement.innerHTML||'';
      if(html.indexOf('v21-rv-hero-featured')!==-1&&!/product-thumb/i.test(src))return;
      window.__FIT_PDP_EG=true;
      fetch(path+'?view=&sections=product-page-v21',{credentials:'same-origin',cache:'no-store',headers:{Accept:'*/*'}})
        .then(function(r){return r.json();})
        .then(function(data){
          var h=data&&data['product-page-v21']; if(!h||h.indexOf('pdpRoot')===-1)return;
          var t=document.querySelector('#MainContent [id^="shopify-section-template"]')||document.querySelector('#MainContent [id*="product-page"]')||document.querySelector('#MainContent [id^="shopify-section"]');
          if(!t)return;
          var d=document.createElement('div'); d.innerHTML=h; var f=d.firstElementChild||d;
          try{window.__fitPdpHydrated=false;window.__fitPdpHydrating=false;}catch(e){}
          t.replaceWith(f); runScripts(f);
          setTimeout(function(){try{if(window.__fitPdpBoot)window.__fitPdpBoot();}catch(e){}},80);
        }).catch(function(){});
    }
    /* UTV/RV collection: page_cache often freezes old main_v11. Old rehydrate
       fetched the dead template section key (returns null). Always pull the
       live static section type instead: collection-utv-v6 / collection-rv-v6. */
    function colGo(){
      try{
        var path=location.pathname||'';
        if(path.indexOf('/collections/')!==0)return;
        /* Always ensure single binder is present (survives page_cache + rehydrate). */
        if(!window.__FIT_COL_FILTERS_SRC){
          window.__FIT_COL_FILTERS_SRC=1;
          var s0=document.createElement('script');
          s0.src='https://fitprotection.com/cdn/shop/t/102/assets/fit-col-filters-v17d.js?v=bind-r3-20260817h';
          s0.async=false;
          (document.head||document.documentElement).appendChild(s0);
        }
        function rebind(){
          try{ if(typeof window.__fitColFiltersBind==='function') window.__fitColFiltersBind(true); }catch(eB){}
        }
        setTimeout(rebind, 50);
        setTimeout(rebind, 400);
        setTimeout(rebind, 1200);

        /* Optional: replace frozen main_v11 shell with live v6 once binder is ready */
        if(window.__FIT_COL_EG)return;
        var html=document.documentElement.innerHTML||'';
        var hasGrid=html.indexOf('id="shopGrid"')!==-1||!!document.getElementById('shopGrid');
        if(!hasGrid)return;
        var staleMarker=html.indexOf('main_v11')!==-1||html.indexOf('fit-col-cache: card-reviews')!==-1;
        if(!staleMarker)return;
        /* If binder already filtered the grid, do not risk a DOM swap */
        var bf0=document.getElementById('brandFilters');
        var rc0=document.getElementById('resultCount');
        var brandQ=(location.search||'').indexOf('brand=')!==-1;
        if(bf0&&bf0.children.length&&rc0&&rc0.textContent&&rc0.textContent!=='—'&&!(brandQ&&rc0.textContent==='22'&&/utv|shop-utv/i.test(path))){
          /* filters look alive */
          return;
        }

        var isRv=/shop-rvs|rv-covers|suffix-rv/i.test(path+' '+(document.body&&document.body.className||''));
        var sec=isRv?'collection-rv-v6':'collection-utv-v6';
        window.__FIT_COL_EG=true;
        var url=path+(location.search?location.search+'&':'?')+'sections='+encodeURIComponent(sec);
        fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'*/*'}})
          .then(function(r){return r.json();})
          .then(function(data){
            var h=data&&data[sec];
            if(!h||h.indexOf('shopGrid')===-1){ try{window.__FIT_COL_EG=false;}catch(eR){} return; }
            var t=document.querySelector('#MainContent [id^="shopify-section-template"]')
              ||document.querySelector('#MainContent [id*="collection"]')
              ||document.querySelector('#MainContent [id^="shopify-section"]')
              ||(document.getElementById('shopGrid')&&document.getElementById('shopGrid').closest('[id^="shopify-section"]'));
            if(!t){ try{window.__FIT_COL_EG=false;}catch(eR3){} return; }
            var d=document.createElement('div'); d.innerHTML=h; var f=d.firstElementChild||d;
            t.replaceWith(f); runScripts(f);
            document.body.setAttribute('data-fit-col-live','v6-eg-bind-r2');
            setTimeout(rebind, 0);
            setTimeout(rebind, 200);
            setTimeout(rebind, 800);
          }).catch(function(){ try{window.__FIT_COL_EG=false;}catch(e1){} });
      }catch(eC){}
    }
    function go(){homeGo();pdpGo();colGo();}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
    setTimeout(go,300); setTimeout(go,1200);
  }catch(e){}
})();
